import React from 'react';
import classNames from 'classnames';
import BgIcon from 'components/atoms/icons/condition-filter-bg.svg?react';
import SlaCrownIcon from 'components/atoms/icons/sla-crown.svg?react';

import s from './styles.module.scss';

interface IProps {
  label: string;
  count: number | string;
  subText?: React.ReactNode;
  bgColor: string;
  onClick?: () => void;
  active?: boolean;
  opacity?: 0.1 | 0.2 | 0.3 | 0.4 | 0.5 | 0.6 | 0.7 | 0.8 | 0.9 | 1;
  showCrown?: boolean;
  titleClassNames?: string;
  countClassNames?: string;
  btnClassNames?: string;
  bgClassNames?: string;
  dataStatus?: string;
}

const StatCard: React.FC<IProps> = (props) => {
  const {
    label,
    count,
    subText,
    bgColor,
    onClick,
    active,
    showCrown,
    titleClassNames,
    countClassNames,
    btnClassNames,
    bgClassNames,
    opacity = 0.4,
    dataStatus,
  } = props;
  return (
    <button
      className={classNames(
        s.item,
        { [s.active]: active, [s.hover]: onClick },
        btnClassNames,
      )}
      onClick={onClick}
      data-status={dataStatus}
    >
      <p
        className={classNames(s.title, titleClassNames)}
        dangerouslySetInnerHTML={{ __html: label }}
      />
      <div>
        <p className={classNames(s.count, countClassNames)}>{count}</p>
        {subText}
      </div>
      <BgIcon
        className={classNames(s.bg, bgClassNames)}
        color={bgColor}
        opacity={opacity}
      />
      {showCrown && <SlaCrownIcon className={s.crown} />}
    </button>
  );
};

export default StatCard;
